import React from 'react';
import PropTypes from 'prop-types';

const Dating = ({ current_date, deleteDating }) => {
    return (
        <div className="dating">
            <p>Mascota: <span>{current_date.pet}</span></p>
            <p>Dueño: <span>{current_date.owner}</span></p>
            <p>Fecha: <span>{current_date.date}</span></p>
            <p>Hora: <span>{current_date.time}</span></p>
            <p>Síntomas: <span>{current_date.symptoms}</span></p>

            <button
                className="button delete u-full-width"
                onClick={() => deleteDating(current_date.id)}
            >Eliminar &times;</button>
        </div>
    );
}

Dating.propTypes = {
    current_date : PropTypes.object.isRequired,
    deleteDating : PropTypes.func.isRequired
}

export default Dating;